var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-wrapper"},[_c('div',{staticClass:"page-title"},[_c('CIcon',{attrs:{"name":"cil-user"}}),_vm._v(" User Analytics ")],1),_c('h1',[_vm._v("COMING SOON")])])}
var staticRenderFns = []

export { render, staticRenderFns }